module.exports = __webpack_public_path__ + "/images/phone-selected.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/phone-selected.svg
// module id = 622
// module chunks = 0